<template>
    <div class="realtime-data-wrap">
        <el-form
            class="leader-style-form leader-form-inline"
            :inline="true"
            :model="searchForm"
            :rules="formRules"
            ref="searchForm"
        >
            <el-form-item label="企业" prop="elec_customer_id">
                <el-select
                    v-model="searchForm.elec_customer_id"
                    @change="selectType(searchForm.elec_customer_id)"
                >
                    <el-option
                        v-for="item in customers"
                        :key="item.elec_customer_id"
                        :label="item.cust_name"
                        :value="item.elec_customer_id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="采集点列表" prop="point_id">
                <el-select v-model="searchForm.point_id" 
                            @focus="selectPoint"
                            filterable
                           v-loading="selectLoading"
                           element-loading-spinner="el-icon-loading"
                           element-loading-background="rgba(0, 0, 0, 0.8)">
                    <el-option
                        v-for="item in points"
                        :key="item.point_id"
                        :label="item.point_name"
                        :value="item.point_id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="起止日期" prop="startEnd">
                <!-- <el-date-picker
                    v-model="searchForm.start"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    :picker-options="startPickerOptions"
                ></el-date-picker> -->
                <el-date-picker
                    v-model="searchForm.startEnd"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="截止日期" prop="end">
                <el-date-picker
                    v-model="searchForm.end"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                ></el-date-picker>
            </el-form-item> -->
            <div>
                <el-button @click="getDataList()">检索</el-button>
                <el-button @click="clear()">清空</el-button>
                <!-- <el-button @click="insetToMysql()">es导出到mysql</el-button> -->
                <!-- <el-button @click="insertToES()">导入es</el-button> -->
            </div>
        </el-form>
        <div class="table-wrap" style="height: calc(100% - 4rem)">
            <el-scrollbar style="height: 90%;width: 100%">
                <el-table
                    class="leader-style-table"
                    style="width: 100%"
                    height="100%"
                    border
                    :data="tableJson"
                    v-loading="loading"
                >
                    <el-table-column
                        v-for="item in tableHeaders"
                        :key="item.column_name"
                        :label="item.column_desc"
                        :property="item.column_name"
                        width="160"
                    ></el-table-column>
                </el-table>
            </el-scrollbar>

            <el-pagination
                class="leader-style-pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 50, 100, 500, 1000]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
    import * as api from "@/http/api";

    export default {
        data() {
            return {
                selectLoading: false,
                customers: [], //企业
                points: [], //采集点数据
                tableHeaders: [],
                tableJson: [],
                twidth: "98.1%",
                searchForm: {
                    elec_customer_id: "",
                    point_id: "",
                    startEnd: ""
                },
                formRules: {
                    elec_customer_id: [
                        {
                            required: true,
                            message: "请选择企业",
                            trigger: "change"
                        }
                    ],
                    point_id: [
                        {
                            required: true,
                            message: "请选择采集点",
                            trigger: "change"
                        }
                    ],
                    startEnd: [
                        {
                            required: true,
                            message: "请选择起止日期",
                            trigger: "change"
                        }
                    ]
                },
                pageNum: 1, //页码
                pageSize: 10, //每页条数
                currentPage: 1, //当前页码
                totalNum: 0, //总条数
                loading: false
            };
        },
        mounted() {
            // this.getType();
            this.getElecCustomerInfoES();
        },
        methods: {

            // 获取用户企业
            getElecCustomerInfoES() {

                api.getElecCustomerInfoES().then(res => {
                    if (res && res.error_code == 0) {
                        this.customers = res.bus_json;
                    }

                });
            },
            selectType(elec_customer_id) {
                this.searchForm.point_id = "";
                this.tableJson = [];
                // this.getPointInfo(type);
                // this.getHeaderInfo(type);
                this.getPointInfo(elec_customer_id);
            },
            selectPoint() {
                if (this.searchForm.elec_customer_id == null || this.searchForm.elec_customer_id == "") {
                    this.$message({
                        type: "warning",
                        message: "请先选择企业"
                    });
                }
            },
            //获取采集点列表
            getPointInfo(elec_customer_id) {
                this.selectLoading = true;
                api.getPointNameListES({ elec_customer_id }).then(res => {
                    if (res) {
                        this.points = res.bus_json;
                    }
                    this.selectLoading = false;
                });
            },
            //获取表头
            getHeaderInfo(point_kind) {
                api.getHeaderInfoES({ point_kind: point_kind }).then(res => {
                    if (res) {
                        this.tableHeaders = res.bus_json;
                    }
                });
            },
            //向MySQL中插入数据
            insetToMysql() {
                this.$refs["searchForm"].validate(valid => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true,
                            text: "Loading",
                            spinner: "el-icon-loading",
                            background: "rgba(0, 0, 0, 0.7)"
                        });
                        api.insetToMysqlES({
                            point_kind: this.searchForm.type,
                            point_id: this.searchForm.point_id,
                            start_day: this.searchForm.startEnd[0],
                            end_day: this.searchForm.startEnd[1]
                        }).then(res => {
                            loading.close();
                            this.$message({
                                type: "success",
                                message: "导出成功"
                            });
                            this.getDataList();
                        });
                    }
                });
            },
            //导入ES
            // insertToES() {
            //     this.$confirm("确认导入ES?", "提示", {
            //         confirmButtonText: "确定",
            //         cancelButtonText: "取消",
            //         type: "warning"
            //     })
            //         .then(() => {
            //             const loading = this.$loading({
            //                 lock: true,
            //                 text: "Loading",
            //                 spinner: "el-icon-loading",
            //                 background: "rgba(0, 0, 0, 0.7)"
            //             });
            //             api.insetToEs({
            //                 point_kind: this.searchForm.type,
            //                 point_id: this.searchForm.point_id,
            //                 start_day: this.searchForm.start,
            //                 end_day: this.searchForm.end
            //             }).then(res => {
            //                 loading.close();
            //                 this.$message({
            //                     type: "success",
            //                     message: "导入成功"
            //                 });
            //             });
            //         })
            //         .catch(() => {
            //             this.$message({
            //                 type: "info",
            //                 message: "导入失败"
            //             });
            //         });
            // },
            /**
             * 列表条数改变回调
             */
            handleSizeChange(e) {
                this.pageNum = 1;
                this.pageSize = e;
                this.getDataList();
            },
            /**
             * 企业列表页码改变回调
             */
            handleCurrentChange(e) {
                this.pageNum = e;
                this.getDataList();
            },
            //获取数据
            getDataList() {

                this.$refs["searchForm"].validate(valid => {
                    if (!valid) {
                        return;
                    }
                    this.loading = true;
                    api.getWiringMeterDataList({
                        point_id: this.searchForm.point_id,
                        show_day: this.searchForm.startEnd[0],
                        to_day: this.searchForm.startEnd[1],
                        pageNum: this.pageNum,
                        pageSize: this.pageSize
                    }).then(res => {
                        if (res) {
                            this.twidth = "98%";
                            this.tableHeaders = res.bus_json.headList;
                            this.tableJson = res.bus_json.dataList;
                            this.totalNum = res.bus_json.count;
                        }
                        this.loading = false;
                    });

                });

            },
            clear() {
                this.searchForm.elec_customer_id = "";
                this.searchForm.point_id = "";
                this.searchForm.startEnd = "";
                this.tableJson = [];
                this.pageNum = 1;//页码
                this.pageSize = 10; //每页条数
                this.currentPage = 1; //当前页码
                this.totalNum = 0; //总条数
            }
        }
    };
</script>
<style lang="scss">
    .realtime-data-wrap {
        height: 100%;
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        overflow-y: auto;
        background: transparent;
        .el-table__body-wrapper {
            height: 90% !important;
        }

        .el-table__empty-block {
           min-height:572px!important;
           overflow-y: auto;
        }
        // // 滚动条的宽度*/
        // .el-table__body-wrapper::-webkit-scrollbar {
        //     width: 8px;
        //     height: 8px;
        //     background: #022d79;
        // }

        // // 滚动条的滑块*/
        // .el-table__body-wrapper::-webkit-scrollbar-thumb {
        //     background-color: #ddd;
        //     border-radius: 3px;
        // }
    }

    // .el-table__empty-block {
    //     width: 100% !important;
    // }
    // .leader-style-form .el-button {
    //     margin: 0 0 0 10px !important;
    // }
</style>
